import { DeletePeerRequest } from './types';
import { storeKeys } from '../../query-key-factory';
import { useStoreApi } from '../../api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const createCauseQuery = (causeId?: string) => {
  return `cause_id=${causeId}`;
};
const useDeletePeer = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const deletePeer = async ({ peerId, peerType, campaignId, causeId }: DeletePeerRequest) => {
    const causeQuery = createCauseQuery(causeId);
    const { data } = await StoreApi.delete(
      `/store_items/${campaignId}/${peerType}/${peerId}?${causeQuery}`
    );
    return data;
  };
  return useMutation({
    mutationFn: deletePeer,
    onSuccess: (_, variables) => {
      const { campaignId, causeId, peerType } = variables;
      return queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.campaigns.id(campaignId)[peerType].all,
      });
    },
  });
};

// delete campaign peer image
const useDeletePeerImage = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const deletePeerImage = async ({ peerId, peerType, campaignId, causeId }: DeletePeerRequest) => {
    const causeQuery = createCauseQuery(causeId);
    const { data } = await StoreApi.delete(
      `store_items/${campaignId}/${peerType}/${peerId}/image?${causeQuery}`
    );
    return data;
  };
  return useMutation({
    mutationFn: deletePeerImage,
    onSuccess: (_, variables) => {
      const { campaignId, causeId, peerType, peerId } = variables;
      return queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.campaigns.id(campaignId)[peerType].id(peerId).detail,
      });
    },
  });
};

export { useDeletePeer, useDeletePeerImage };
